/**
 * Created by Ning Jiang on 2/21/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BurningWildReelSymbol} from "../../reelsymbol/BurningWildReelSymbol";
import {SymbolBurstAnimator} from "../../reelsymbol/SymbolBurstAnimator";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {WildNudgeHelper} from "../../utils/WildNudgeHelper";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";

export class WildLandingPresentationController extends ReelStopPresentationController {

    private _nudgeData:WildNudgeParsedGameData | null;

    constructor(index:number) {
        super(index, "WildLanding");
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData):void {
        this._nudgeData = data;
    }

    public onReelBounce(data:IReelStoppedData):void {
        const wildIndex:number = WildNudgeHelper.findStackedSymbolBottomPositionFromReelData("W", data.reelId, this._gameData!.reels[data.reelId], 0);
        if(!isNaN(wildIndex)) {
            if(wildIndex >= 0 && wildIndex < 7) {
                EventHandler.dispatchEvent(new GameEvent(SymbolBurstAnimator.PLAY_STACKED_SMOKE, data.reelId, 3));
                SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.WILD_LANDING);
            }
            // Stop fire if no nudge.
            const shouldNudge:boolean = this._nudgeData!.betWins != null && this._nudgeData!.betWins.length > 0 && this._nudgeData!.doReelNudge[data.reelId];
            if(!shouldNudge) {
                const wild:BurningWildReelSymbol = <BurningWildReelSymbol>Reels.getSymbol(data.reelId, Math.min(4, wildIndex));
                if(wild) {
                    // If the wild lands just on top of the view area, it should play fire when spin start again.
                    wild.stopFireOverlay(0.5, true, wildIndex != -1);
                }
            }
        }

        this.dispatchCompleteEvent(data.reelId);
    }
}